<template>
  <div class="staff-group">
    <span class="label">{{ name }}</span>
    <div
      v-for="(workSpace, j) in workSpaces"
      :key="j"
      class="staff"
      v-show="!workSpace.isReserve"
    >
      <template v-if="workSpace.workSchedules.length">
        <work-schedule-item
          v-for="workSchedule in workSpace.workSchedules"
          :key="`wsch-${workSchedule.id}`"
          :users="workSpace.users"
          :work-schedule="workSchedule"
          :work-space="workSpace"
          :readonly="readonly"
        />
      </template>
      <template v-else>
        <work-schedule-item
          :key="`wschs-${workSpace.id}`"
          :users="workSpace.users"
          :work-space="workSpace"
          :readonly="readonly"
        />
      </template>
    </div>
    <v-row>
      <v-col cols="4">
        <v-btn
          :disabled="readonly"
          v-if="hasReserveWorkSpaces"
          @click="showWorkSpaceFromReserve(groupKey)"
          block
          class="add-workspace-btn"
        >
          <font-awesome-icon icon="plus" />
          ДОБАВИТЬ СОТРУДНИКА
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  // import WorkSpaceItem from '@/components/administrator/work-shift/staff/WorkSpaceItem'
  import WorkScheduleItem from '@/components/administrator/work-shift/staff/WorkScheduleItem'
  // import { mapActions, mapMutations } from 'vuex'
  export default {
    name: 'WorkSpaceGroup',
    components: { WorkScheduleItem },
    props: {
      name: {
        type: String,
      },
      groupKey: {
        type: Number,
      },
      workSpaces: {
        type: Array,
        default: () => [],
      },
      readonly: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      hasReserveWorkSpaces () {
        return this.workSpaces.filter((ell) => ell.isReserve).length > 0
      },
    },
    methods: {
      showWorkSpaceFromReserve (groupKey) {
        this.$store.commit('dayWorkSchedule/showWorkSpaceFromReserve', groupKey)
      },
    },
  }
</script>

<style lang="less" scoped>
.staff-group {
  margin-bottom: 55px;

  .label {
    display: block;
    margin-bottom: 25px;
    font-size: 24px;
    font-weight: normal;
    @media(max-width: @sm) {
      margin-bottom: 35px;
    }
  }

  .add-workspace-btn {
    svg {
      margin-right: 10px;
      color: #FB8C00;
    }
  }

}
</style>
